import type {
  OrderDetailToPrint,
  UserType,
  VerifyUserTypeParams,
} from './orderToPrint.model';

export function checkIfHasOrderToPrint(order: OrderDetailToPrint) {
  return Boolean(order.id);
}

export function calcTotalUnitsOfOrder(prods: OrderDetailToPrint['products']) {
  return prods.reduce((acc, product) => acc + product.units, 0);
}

export function verifyUserType(params: VerifyUserTypeParams): UserType {
  const { isNewUser, highValueUser } = params;
  let userType: UserType = null;
  if (isNewUser && highValueUser) userType = 'both';
  else if (isNewUser) userType = 'new';
  else if (highValueUser) userType = 'pro';
  return userType;
}
